var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      staticStyle: { "z-index": "100000" },
      attrs: {
        id: "container",
        title: "¡Chanfle! Algo pasó...",
        "hide-footer": "",
        centered: "",
        noCloseOnBackdrop: "",
        "data-cy": "api-error-modal",
      },
      on: {
        close: function ($event) {
          return _vm.onModalClose()
        },
      },
      model: {
        value: _vm.errorModal,
        callback: function ($$v) {
          _vm.errorModal = $$v
        },
        expression: "errorModal",
      },
    },
    [
      _c("div", [
        _c(
          "div",
          {
            staticClass: "container",
            attrs: { "data-cy": "api-error-modal-container" },
          },
          [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-sm-12 col-md-3" },
                [
                  _c(
                    "vs-chip",
                    { staticClass: "h5" },
                    [
                      _c("vs-avatar", {
                        attrs: {
                          size: "30px",
                          color: "#7367f0",
                          icon: "sentiment_dissatisfied",
                        },
                      }),
                      _vm._v(" Cód: "),
                      _c("b", { staticClass: "ml-1" }, [
                        _vm._v(_vm._s(_vm.apiError.codigo)),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-sm-12 col-md-9" },
                _vm._l(_vm.apiError.errores, function (error, index) {
                  return _c("vs-list-item", {
                    key: index,
                    attrs: {
                      icon: "error_outline",
                      title: error,
                      "data-cy": "api-error-modal-container-error",
                    },
                  })
                }),
                1
              ),
              _c(
                "div",
                { staticClass: "col-12 my-4" },
                [
                  _c("div"),
                  _c(
                    "vs-list",
                    [
                      _c("vs-list-header", {
                        attrs: {
                          title: _vm.apiError.mensaje,
                          "data-cy": "api-error-modal-container-mensaje",
                        },
                      }),
                      _c("vs-list-item", {
                        class: { "text-success": _vm.wasCopied },
                        staticStyle: { cursor: "pointer" },
                        attrs: {
                          icon: _vm.copyIcon,
                          title: _vm.apiError.seguimientoId,
                          subtitle: "Click para copiar automáticamente",
                        },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.copyToClipboard.apply(null, arguments)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]
        ),
        _c("div", { staticClass: "row justify-content-end" }, [
          _c(
            "div",
            { staticClass: "col-auto" },
            [
              _c(
                "b-button",
                {
                  attrs: { variant: "outline-primary" },
                  on: { click: _vm.copyToClipboard },
                },
                [_vm._v(" Copiar ")]
              ),
              _c(
                "b-button",
                {
                  staticClass: "ml-3",
                  attrs: { variant: "outline-secondary" },
                  on: { click: _vm.clearError },
                },
                [_vm._v(" Cerrar ")]
              ),
            ],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }